// ---------------
// 应收开票状态
// ---------------
export const BILLING_INVOICE_AR = 'billing._invoiceStateAr_'
export const BILLING_INVOICE_AR_NATIVE = 'billing._INVOICE_STATE_AR_'
export const JOB_INVOICE_STATE_ALL = 'job._invoiceStateAll_'
export const JOB_INVOICE_STATE_AR = 'job._invoiceStateAr_'
export const JOB_INVOICE_STATE_AP = 'job._invoiceStateAp_'
export const JOB_INVOICE_NATIVE = 'job._INVOICE_VOUCHERED_'
export const BILLING_GROUP_INVOICE_STATE = 'billingGroup._invoiceState_'
export const BILLING_GROUP_INVOICE_STATE2 = 'billingGroup._invoiceState2_'
export const ACTUAL_AMOUNT_INVOICE_STATE = 'actualAmount._invoiceState_'

// ---------------
// 应收开票日期
// ---------------
export const JOB_INVOICE_DATE_AR = 'job._invoiceDateAr_'

// ---------------
// 凭证
// ---------------

export const INVOICE_VOUCHERED_NATIVE = 'charge._INVOICE_VOUCHERED_'
export const BILLING_VOUCHERED_NATIVE = 'charge._BILLING_VOUCHERED_'
export const JOB_VOUCHERED_NATIVE = 'charge._JOB_VOUCHERED_'
export const ACTUAL_AMOUNT_VOUCHERED_NATIVED = 'clearHistory._ACTUAL_AMOUNT_VOUCHERED_'
export const BILLPAYMENT_VOUCHERED_NATIVED = 'charge._BILLPAYMENT_VOUCHERED_'
export const INVOICE_VOUCHERED = 'charge._invoiceVouchered_'
export const BILLING_VOUCHERED = 'charge._billingVouchered_'
export const JOB_VOUCHERED = 'charge._jobVouchered_'
export const ACTUAL_AMOUNT_VOUCHERED = 'clearHistory._actualAmountVouchered_'
export const BILLPAYMENT_VOUCHERED = 'charge._billPaymentVouchered_'
// CARGO-741，已生成凭证查询界面增加筛选项对方凭证号
export const INVOICE_TARGET_DOCUMENT_NO_NATIVE = 'charge._TARGET_DOCUMENT_NO_'
export const ACTUAL_AMOUNT_TARGET_DOCUMENT_NO = 'clearHistory._TARGET_DOCUMENT_NO_'

// ---------------
// Job
// ---------------

export const LOAD_RELATION_JOBS = 'loadRelationJobs'

// 航线
export const CHARGE_REGION = 'charge._region_'
export const JOB_REGION = 'job._region_'
export const JOB_REGIONHQL = 'job._regionhql_'

// ---------------
// Partner
// ---------------
// 签约
export const CONTRACT_SIGN = 'contract._sign_'
// 签约状态
export const CONTRACT_STATUS = 'contract._status_'

// 客户级别
export const CUSTOMER_LEVEL = 'customer._level_'

// 是否是MSC订舱模块
export const JOB_IS_MSC = 'job._isMsc'

// 业务状态
export const TRACKING_INFO_MULTIPLE_STATE = 'trackingInfo._multipleState_'
